import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    IProductCentreSearchParams,
    ProductCentreLogicService
} from '@app/logic/product-centre/product-centre.logic.service';
import { IProductCentreDocumentDto, ProductSearchTypeEnumId, } from '@classictechsolutions/hubapi-transpiled-enums';
import { Observable, take } from 'rxjs';
import { SearchService } from './base.search.service';

@Injectable()
export class ProductCentreSearchService extends SearchService {
    public categoryIds: number[];
    public productType: ProductSearchTypeEnumId;
    public activeOnly: boolean;
    public businessEntityIdsToFilterBy: number[];
    public businessEntityIdsToSortBy: number[];
    public ignoreTierBasedSorting: boolean;

    public get extraSearchParams(): IProductCentreSearchParams {
        return {
            cat: this.categoryIds,
            t: this.productType,
            ao: this.activeOnly,
            bes: this.businessEntityIdsToSortBy,
            bef: this.businessEntityIdsToFilterBy,
            ignoreTierBasedSorting: this.ignoreTierBasedSorting
        } as IProductCentreSearchParams;
    }

    constructor(
        public readonly logicService: ProductCentreLogicService,
        public readonly dialog: MatDialog
    ) {
        super();
    }

    public getResults(query: string, currentPage: number): Observable<IProductCentreDocumentDto[]> {
        return new Observable<IProductCentreDocumentDto[]>(subscriber => {
            if (!this.searchResultsLoaded) {
                this.searchResultsLoaded = true;
                const resultsObservable = this.logicService.$getSearchList({
                    query,
                    currentPage,
                    pageSize: this.pageSize,
                    ...this.extraSearchParams
                });
                resultsObservable
                    .pipe(take(1)).subscribe(x => {
                        this.setSearchResults<IProductCentreDocumentDto>(x);
                        subscriber.next(this.searchResults$.value as IProductCentreDocumentDto[]);
                        subscriber.complete();
                    });
            } else {
                subscriber.next(this.searchResults$.value as IProductCentreDocumentDto[]);
                subscriber.complete();
            }
        });
    }

    public readonly doSearch = (
        query: string,
        page: number
    ): Observable<IProductCentreDocumentDto[]> => {
        this.searchResultsLoaded = false;
        return this.getResults(query, page).pipe(take(1));
    };
}
